import type { ReactNode } from 'react'

type V2CatalogPageHeaderProps = {
  title: string
  subtitle: string
  actions?: ReactNode
}

export function V2CatalogPageHeader({
  title,
  subtitle,
  actions,
}: V2CatalogPageHeaderProps) {
  return (
    <header className="flex flex-wrap items-center justify-between gap-2">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">{title}</h1>
        <p className="text-muted-foreground">{subtitle}</p>
      </div>
      {actions}
    </header>
  )
}
